module.exports = __webpack_public_path__ + "static/media/SUV & Crossover.18afb241.png";